// react
import React, {  useContext } from 'react';
import useForm from 'react-hook-form';
import Datetime from "react-datetime";
import { useTranslation } from 'react-i18next';

// material-ui icons

// material-ui components
import TextField from '@material-ui/core/TextField';
import FormHelperText from "@material-ui/core/FormHelperText";
import CircularProgress from '@material-ui/core/CircularProgress';

// core components
import GridContainer from "beaktShared/components/Grid/GridContainer.js";
import GridItem from "beaktShared/components/Grid/GridItem.js";
import Button from "beaktShared/components/CustomButtons/Button.js";

// services
import { convertDate, getLocale, getStringFormatDate, MaskMoney, transformValueFormatedtoFloat, transformValueFloattoFormated, MaskOnlyNumbersStart1,MaskOnlyNumbers} from "beaktShared/helpers/masks";

// style
import { makeStyles } from "@material-ui/core/styles";
import styles from "assets/jss/BeaktClinic/views/Venda/pagamentoDinheiro.js";
const useStyles = makeStyles(styles);


export default function PagamentoCheque({ pgto, CallloadTotalizadorPgtosCq }) {
  const { t } = useTranslation();
  const classes = useStyles();
  const {register, errors, handleSubmit, setValue} = useForm({mode: "onBlur"}); 
    
  const [messageReturn,setmessageReturn]= React.useState({
    show:false,
    message:''
  });

  const [LoadingForm,setLoadingForm]= React.useState(false);
  const onSubmit = (data, e) => {
    e.preventDefault();
    
    setLoadingForm(true);
    let valor = transformValueFormatedtoFloat(data.valor);
    if(valor > pgto.totalizadorPagamentos.valorPendente.toFixed(2))
    {
      setmessageReturn({
        show:true,
        message:t('error_message.the_amount_must_be_equal_or_less_than_the_balance_to_pay')
      });    
      setLoadingForm(false);  
      return false;
    }

    let descParcelas = "";
    if(parseInt(data.parcelas)===1)
      descParcelas = "1x";
    else
    {
      let valorPacela = valor / parseInt(data.parcelas);
      descParcelas = data.parcelas + "x "+transformValueFloattoFormated(valorPacela);
    }

    var dataprimeirovencTratado = convertDate(data.primeirovenc);

    let pg = {
      id:pgto.pagamentos.length+1,
      tipo:3, //0- Dinheiro / 1-Cartão / 2-Boleto / 3-Cheque / 4-Outros
      descricaoFormaPgto: 'Cheque',
      valor:valor,
      descTipo: t('sale.check'),
      parcela:data.parcelas,
      descPacela:descParcelas,
      dadosComplementarCheque:{
        banco: data.banco,
        agencia: data.agencia,
        numeroPrimeiroCheque: data.numeroPrimeiroCheque,
        primeiroVenc: dataprimeirovencTratado
      }
    }

    let updatepgto ={
      ...pgto,        
      pagamentos:[
        ...pgto.pagamentos,
        pg
      ]
    };

    clearForm();
    setmessageReturn({show:false})
    setLoadingForm(false);  
    CallloadTotalizadorPgtosCq(updatepgto);   
    return true;
  }

  const clearForm = () =>{
    setValue("banco","");
    setValue("agencia","");
    setValue("numeroPrimeiroCheque","");
    setValue("primeirovenc","");
    setValue("valor","");
    setValue("parcelas",1);
  }

  var yesterday = Datetime.moment().subtract( 1, 'day' );
  var valid = function( current ){
      return current.isAfter( yesterday );
  };
    
return (
    <div>          
      <form onSubmit={handleSubmit(onSubmit)}>    

      <GridContainer className={classes.containerin}>
        <GridItem xs={12} sm={4} md={4}>
          <div className={classes.labelIdent}>
          {t('label.bank')} *
          </div>
        </GridItem>
        <GridItem xs={12} sm={4} md={3}>
            <TextField
                fullWidth
                variant="outlined"
                InputLabelProps={{shrink: true}} 
                defaultValue="" 
                name="banco"       
                inputProps={{maxLength: 3}}   
                onInput={(e) => MaskOnlyNumbers(e) }               
                inputRef={register({required: true})}
                error={errors.banco?true:false} 
            />
            <FormHelperText>
                {errors.banco && <span className="obg">{t('label.required')}</span>}
            </FormHelperText>   
        </GridItem>        
      </GridContainer>   

      <GridContainer className={classes.containerin}>
        <GridItem xs={12} sm={4} md={4}>
          <div className={classes.labelIdent}>
          {t('label.agency')} *
          </div>
        </GridItem>
        <GridItem xs={12} sm={5} md={4}>
            <TextField
                fullWidth
                variant="outlined"
                InputLabelProps={{shrink: true}} 
                defaultValue="" 
                name="agencia"       
                inputProps={{maxLength: 10}}   
                onInput={(e) => MaskOnlyNumbers(e) }               
                inputRef={register({required: true})}
                error={errors.agencia?true:false} 
            />
            <FormHelperText>
                {errors.agencia && <span className="obg">{t('label.required')}</span>}
            </FormHelperText>   
        </GridItem>        
      </GridContainer>   

      <GridContainer className={classes.containerin}>
        <GridItem xs={12} sm={4} md={4}>
          <div className={classes.labelIdent}>
            Nº {t('sale.check')} 1º  *
          </div>
        </GridItem>
        <GridItem xs={12} sm={5} md={4}>  
            <TextField
                fullWidth
                variant="outlined"
                InputLabelProps={{shrink: true}} 
                defaultValue="" 
                name="numeroPrimeiroCheque"       
                inputProps={{maxLength: 10}}   
                onInput={(e) => MaskOnlyNumbers(e) }               
                inputRef={register({required: true})}
                error={errors.numeroPrimeiroCheque?true:false} 
            />
            <FormHelperText>
                {errors.numeroPrimeiroCheque && <span className="obg">{t('label.required')}</span>}
            </FormHelperText>   
        </GridItem>        
      </GridContainer>   

      <GridContainer className={classes.containerin}>
        <GridItem xs={12} sm={4} md={4}>
          <div className={classes.labelIdent}>
          1º {t('label.due_date')} *
          </div>
        </GridItem>
        <GridItem xs={12} sm={5} md={4}>
          <Datetime
            locale={getLocale()}
            dateFormat={getStringFormatDate()}
            timeFormat={false}
            name="primeirovenc"  
            isValidDate={ valid }                
            inputProps={{ name:"primeirovenc", ref:register({required: true}), readOnly:'readonly' }} 
            className={errors.primeirovenc?"error":""}            
          />                 
          <FormHelperText>
              {errors.primeirovenc && <span className="obg">{t('label.required')}</span>}
          </FormHelperText>
        </GridItem>        
      </GridContainer>                 
                                      
      <GridContainer className={classes.containerin}> 
        <GridItem xs={12} sm={4} md={4}>
          <div className={classes.labelIdent}>
          {t('label.value')} *
          </div>
        </GridItem>
        <GridItem xs={12} sm={5} md={4}> 
            <TextField
                fullWidth
                variant="outlined"
                InputLabelProps={{shrink: true}} 
                defaultValue=""  
                name="valor"               
                InputProps={{ inputComponent: MaskMoney}}    
                inputRef={register({required: true})}
                error={errors.valor?true:false} 
            />
            <FormHelperText>
                {errors.valor && <span className="obg">{t('label.required')}</span>}
            </FormHelperText>   
        </GridItem>
      </GridContainer>

      <GridContainer className={classes.containerin}>
        <GridItem xs={12} sm={4} md={4}>
          <div className={classes.labelIdent}>
           Nº {t('label.parcel')} *
          </div>
        </GridItem>
        <GridItem xs={12} sm={3} md={2}>
            <TextField
                fullWidth
                variant="outlined"
                InputLabelProps={{shrink: true}} 
                name="parcelas"                  
                defaultValue={1}      
                type="number"                                                   
                inputProps={{maxLength: 3}} 
                onInput={(e) => MaskOnlyNumbersStart1(e) }          
                inputRef={register({required: true})}
                error={errors.parcelas?true:false} 
            />
            <FormHelperText>
                {errors.parcelas && <span className="obg">{t('label.required')}</span>}
            </FormHelperText>   
        </GridItem>   
        <GridItem xs={12} sm={5} md={5}>
          <br/>
           <small>({t('information_message.inform_the_number_of_parcels')})</small>
        </GridItem>       
      </GridContainer>

     
      <GridContainer className={classes.containerin}>
        <GridItem xs={12} sm={12} md={12}>
            {messageReturn.show &&
            <div className="alertErrorEx alertmax">
                <p>
                {messageReturn.message}   
                </p>
            </div>
            }
            <br/>
            <center>
            <Button type="submit" color="primary" >
            {t('button.post_payment')}                      
            </Button>
            {LoadingForm && <CircularProgress />}
            </center>
        </GridItem>
      </GridContainer>
      </form>
    
    </div>
);
}